export enum ProductsActionTypes {
  GET_LIST_PRODUCTS_SUCCESS = "PRODUCTS_GET_LIST_SUCCESS",
  GET_LIST_PRODUCTS_ERROR = "PRODUCTS_GET_LIST_ERROR",
  GET_LIST_PRODUCTS = "PRODUCTS_GET_LIST",
  CREATE_PRODUCT = "CREATE_PRODUCT",
  CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS",
  CREATE_PRODUCT_ERROR = "CREATE_PRODUCT_ERROR",
  GET_PRODUCT = "GET_PRODUCT",
  GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS",
  GET_PRODUCT_ERROR = "GET_PRODUCT_ERROR",
  UPDATE_PRODUCT = "UPDATE_PRODUCT",
  UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS",
  UPDATE_PRODUCT_ERROR = "UPDATE_PRODUCT_ERROR",
  DELETE_PRODUCT = "DELETE_PRODUCT",
  DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS",
  DELETE_PRODUCT_ERROR = "DELETE_PRODUCT_ERROR",
}
